import createMuiTheme from '@material-ui/core/styles/createMuiTheme'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import React from 'react'

const caTheme = createMuiTheme({ breakpoints: { values: { xs: 0, sm: 521, md: 769, lg: 1050, xl: 1200 } } })

export const CaThemeProvider = ({ children }) => (
  <MuiThemeProvider theme={caTheme}>
    {children}
  </MuiThemeProvider>
)
